export default __webpack_public_path__ + "static/media/icompras-logo.85974422.svg";